/**
 * Convert an inclusive local calendar date (`YYYY-MM-DD`, as the range picker
 * produces) to the ISO instant where that day starts/ends in the USER'S
 * timezone. The overview stats endpoints take absolute instants; framing the
 * picked days locally keeps "July 1" meaning the user's July 1 — matching the
 * old home dashboard's behavior (product call on the SD-10609 review).
 */
export const localDayStartIso = (date: string): string => {
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day, 0, 0, 0, 0).toISOString();
};

export const localDayEndIso = (date: string): string => {
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day, 23, 59, 59, 999).toISOString();
};
